import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();

  const add = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product);
    toast.success(`${product.name} added to your basket`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className={index % 2 === 1 ? "md:mt-10" : ""}
    >
      <Link to={`/product/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
        <div className="relative overflow-hidden rounded-t-[6rem] rounded-b-3xl bg-surface aspect-[3/4]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105"
            style={{ transition: "transform 0.7s cubic-bezier(0.22,1,0.36,1)" }}
          />
          <button
            onClick={add}
            data-testid={`add-to-cart-${product.slug}`}
            aria-label={`Add ${product.name} to cart`}
            className="absolute bottom-4 right-4 w-11 h-11 rounded-full bg-cream/90 backdrop-blur text-forest flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 hover:bg-terracotta hover:text-cream"
            style={{ transition: "opacity 0.4s ease, transform 0.4s ease, background-color 0.3s ease, color 0.3s ease" }}
          >
            <Plus className="w-5 h-5" />
          </button>
        </div>
        <div className="pt-5">
          <div className="flex items-baseline justify-between gap-3">
            <h3 className="font-serif text-2xl text-forest leading-tight">{product.name}</h3>
            <span className="text-sm text-terracotta font-semibold whitespace-nowrap">{product.price_note?.replace("from ", "") || `$${product.price}`}</span>
          </div>
          {product.vibe && (
            <div className="flex flex-wrap gap-2 mt-3">
              {product.vibe.slice(0, 3).map((v) => (
                <span key={v} className="text-[0.65rem] uppercase tracking-[0.12em] text-forest-soft bg-surface rounded-full px-3 py-1">
                  {v}
                </span>
              ))}
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  );
}
